import React from 'react';
import { Check, Code2, CreditCard, Rocket, LifeBuoy } from 'lucide-react';
import { Button } from './ui/button';
import { studioReasons } from '../mock';

const services = [
  { icon: Code2, title: 'Custom Software', subtitle: 'Built for Your Business' },
  { icon: CreditCard, title: 'Flexible Payment Plans', subtitle: 'Pay Over Time' },
  { icon: Rocket, title: 'End-to-End Service', subtitle: 'PayFly Support' },
  { icon: LifeBuoy, title: 'Ongoing Support', subtitle: 'Maintenance & Growth' },
];

const Studio = ({ onBookCall }) => {
  return (
    <section id="studio" className="relative py-8">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-gradient-to-br from-[#0d0616] via-[#0a0a18] to-[#0a0616]">
          <div className="grid lg:grid-cols-[380px_1fr_320px]">
            {/* LEFT - Image panel */}
            <div className="relative min-h-[380px] bg-[#000000] flex items-center justify-center overflow-hidden">
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(168,85,247,0.28),transparent_70%)]" />
              <div className="relative z-10 text-center px-6">
                <img
                  src="/logos/blkpixel-logo.png"
                  alt="BLKPixel Studio"
                  className="max-w-[260px] w-full mx-auto"
                  style={{ mixBlendMode: 'lighten' }}
                />
                <div className="text-[#a855f7] text-[11px] tracking-[0.5em] mt-1 font-light">
                  S T U D I O
                </div>
              </div>
              {/* Fake terminal lines */}
              <div className="absolute bottom-6 left-6 right-6 space-y-1.5 opacity-40">
                <div className="h-1 rounded bg-[#a855f7]/40 w-3/4" />
                <div className="h-1 rounded bg-[#a855f7]/30 w-1/2" />
                <div className="h-1 rounded bg-[#a855f7]/20 w-2/3" />
              </div>
            </div>

            {/* MIDDLE - Content */}
            <div className="p-8 lg:p-10">
              <div className="text-[13px] font-semibold bg-gradient-to-r from-[#a855f7] to-[#60a5fa] bg-clip-text text-transparent mb-2">
                Our Agency
              </div>
              <h3 className="text-white text-[32px] lg:text-[36px] font-bold tracking-tight">
                BLKPixel Studio
              </h3>
              <p className="text-gray-400 text-[14px] mt-3 max-w-[500px] leading-relaxed">
                Your ideas deserve more than templates. Our agency builds custom software, web & mobile apps, AI solutions, and automations that deliver real results.
              </p>

              <div className="grid grid-cols-2 gap-4 mt-6">
                {services.map((s) => (
                  <div key={s.title} className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center flex-shrink-0">
                      <s.icon className="w-4 h-4 text-[#a855f7]" />
                    </div>
                    <div>
                      <div className="text-white text-[13.5px] font-semibold">{s.title}</div>
                      <div className="text-gray-500 text-[11.5px]">{s.subtitle}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT - Why Work With Us */}
            <div className="p-6 lg:p-8 border-l border-white/5 bg-black/20">
              <div className="text-white font-semibold text-[15px] mb-4">Why Work With Us?</div>
              <div className="space-y-3">
                {studioReasons.map((r) => (
                  <div key={r} className="flex items-center gap-2.5 text-[13px] text-gray-300">
                    <div className="w-4 h-4 rounded-full bg-[#a855f7]/20 flex items-center justify-center flex-shrink-0">
                      <Check className="w-2.5 h-2.5 text-[#a855f7]" strokeWidth={3} />
                    </div>
                    {r}
                  </div>
                ))}
              </div>

              <Button
                onClick={onBookCall}
                className="w-full mt-5 h-10 rounded-md text-[13px] font-semibold bg-gradient-to-r from-[#7c3aed] to-[#4f46e5] hover:from-[#8b45f0] hover:to-[#5b52ee] text-white shadow-[0_0_20px_rgba(124,58,237,0.35)] border-0"
              >
                Book a Free Consultation
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Studio;
